exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price{font-size:24px;font-weight:700;color:#0092c9}.video-container{position:relative;padding-bottom:56.25%;padding-top:30px;height:0;overflow:hidden}.video-container embed,.video-container iframe,.video-container object{position:absolute;top:0;left:0;width:100%;height:100%}.product-info{color:#000;text-decoration:none}body{background-color:#fff}a.btn{padding:10px 15px;border-radius:5px;background-color:#0092c9;color:#fff}", ""]);

// exports
